<template>
  <div class="dependency-block">
    <div>
      <div class="parent-block">
        <label>
          Parent Field
          <tooltip :text="TOOLTIP_TEXT.DEPENDENCY"></tooltip>
        </label>
        <select name="parent" ref="parent" @change="setOptions()">
          <option value="" :selected="!parentInput">
            <span class="placeholder"></span>
          </option>
          <option
            v-for="(dependency, index) in dependencyList"
            :key="index"
            :value="dependency.metadata.fieldName"
            :selected="parentInput === dependency.metadata.fieldName"
          >
            {{ dependency.metadata.label }}
          </option>
        </select>
      </div>
      <div class="exist-dependency" v-if="dependencyData.parent">
        <div class="exist-text">
          <div v-for="value, index in dependencyData.displayIfValues" :key="value" class="exist-values">
            {{ value }}: <span class="values-label">{{ valuesLabel[index] }}</span>
          </div>
        </div>
        <span class="remove" @click="removeDependency()">&#9866;</span>
      </div>
    </div>
    <div>
      <div class="values-block">
        <div class="values-input-block">
          <label class="values-input-label">
            Component will only show if parent value/s is/are
          </label>
          <input
            type="email"
            name="displayIfValues"
            ref="displayIfValues"
            list="dependencyDatalist"
            multiple
            autocomplete="off"
            :value="dependencyData.displayIfValues"
            @focus="setInputType($event, 'email')"
            @blur="clickSetDependency($event)"
            @change="updateDatalist($event)"
          />
          <datalist id="dependencyDatalist"> </datalist>
          <span class="hint">Multiple values should be comma-delimited</span>
        </div>
        <app-button @onclick="addDependency()" class="button" ref="setDependency" hidden>Set</app-button>
      </div>
    </div>
    
  </div>
</template>

<script>
import AppButton from "./AppButton.vue";
import Tooltip from "./Tooltip.vue";
import { Bus } from "../main";
import { MESSAGES, TOOLTIP_TEXT } from "../mixins/constant-mixin";

// append to the end of datalist option
// to detect if the user selected an datalist option
const invi_separator = "\u2063";

export default {
  name: "DependencyEditor",
  props: {
    dependency: {
      type: Object,
      required: true,
    },
    fieldName: {
      type: String
    }
  },
  data() {
    return {
      dependencyData: structuredClone(this.dependency),
      dependencyList: [],
      HINT: MESSAGES.DEPENDENCY_HINT,
      TOOLTIP_TEXT: TOOLTIP_TEXT,
      showInput: !!this.dependency.parent,
      parentInput: this.dependency.parent,
      valuesLabel: [],
    };
  },
  components: {
    "app-button": AppButton,
    "tooltip": Tooltip,
  },
  methods: {
    addDependency: function () {
      const parent = this.$refs.parent.value;
      let displayIfValues = this.$refs.displayIfValues.value
      if (parent.trim() == "" || displayIfValues.trim() == "") {
        return;
      }
      displayIfValues = this.createArrayFromString(displayIfValues.replaceAll(invi_separator, ""));
      const newDependency = {parent: parent, displayIfValues: displayIfValues}
      this.dependencyData = newDependency;
      this.setValuesLabel();
      this.$emit("addDependency", newDependency);
    },
    createArrayFromString: function (str) {
      // remove duplicates using Set
      let set = new Set(str.split(","));
      // remove empty value
      set.delete('');
      return [...set];
    },
    removeDependency: function () {
      this.dependencyData = {};
      this.parentInput = "";
      document.getElementById("dependencyDatalist").innerHTML = "";
      this.$emit("removeDependency");
    },
    setOptions: function() {
      if (this.$refs.parent && !this.$refs.parent.value) {
        this.showInput = false;
      } else {
        this.showInput = true;
        this.$nextTick(() => {
          this.setDatalist(this.$refs.parent.value);
        });
      }
      this.dependencyData.parent = "";
      this.dependencyData.displayIfValues = "";
      this.parentInput = this.$refs.parent.value;
    },
    setDatalist: function (parentValue) {
      const datalist = document.getElementById("dependencyDatalist");
      datalist.innerHTML = "";
      const parent = this.dependencyList.find(
        (field) => field.metadata.fieldName === parentValue
      );
      if (!parent) {
        return;
      }
      const options = parent.metadata.options;
      for (let i = 0; i < options.length; i++) {
        const option = document.createElement("option");
        option.setAttribute("value", (options[i].value + invi_separator));
        option.innerText = options[i].label;
        datalist.appendChild(option);
      }
    },
    clickSetDependency: function (event) {
      this.$refs.setDependency.$el.click();
      this.setInputType(event, 'text');
    },
    setInputType: function (event, type) {
      if (event.type === "focus") {
        event.target.focus();
      }
        this.$nextTick(() => event.target.setAttribute("type", type));
    },
    setValuesLabel: function () {
      this.valuesLabel = [];
      const parentField = this.dependencyList.find(field => field.metadata.fieldName === this.dependencyData.parent);
      this.dependencyData.displayIfValues.forEach(val => {
        const option = parentField.metadata.options.find(opt => opt.value == val);
        if (option) {
          this.valuesLabel.push(option.label);
        }
      });
    },
    updateDatalist: function (event) {
      const value = event.target.value;
      if (value[value.length-1] === invi_separator) {
        // remove selected datalist option
        let lastValue = value.split(",").filter(val => !!val);
        lastValue = lastValue[lastValue.length-1];
        const datalist = document.getElementById("dependencyDatalist");
        let newDatalist = "";
        datalist.childNodes.forEach(node => {
          if (node.value !== lastValue) {
            newDatalist += node.outerHTML;
          }
        })
        datalist.innerHTML = newDatalist;

        // add comma to show the datalist again
        event.target.value += ",";
      }
    }
  },
  mounted() {
    if (this.parentInput) {
      this.$nextTick(() => this.setDatalist(this.dependencyData.parent));
    }

    if (this.dependencyData && this.dependencyData.parent) {
      this.$nextTick(() => this.setValuesLabel());
    }

    // emit from FormEditor
    Bus.$on("dependencyList", (list) => {
      this.dependencyList = list.filter(item => {
        if (item.metadata.fieldName === this.fieldName){
          return false;
        }
        if (item.metadata.dependency) {
          if (item.metadata.dependency.parent === this.fieldName) {
            return false;
          } 
        } 
        return true;
      });
    });
  },
  beforeDestroy() {
    Bus.$off("dependencyList");
  }
};
</script>

<style scoped>
.dependency-block {
  display: flex;
  flex-direction: row;
  align-items: baseline;
}

.dependency-block select,
.dependency-block input {
  margin-top: 4px;
  padding: 8px;
}

.dependency-block > div {
  width: 100%;
}

.parent-block {
  display: flex;
  flex-direction: column;
}

.values-block {
  display: flex;
  align-items: center;
  margin: 0 1rem;
}

.values-input-block {
  display: flex;
  flex-direction: column;
}

.values-input-label {
  font-size: 13px;
  padding: 0 2px;
  white-space: nowrap;
}

.exist-dependency {
  background: #edecec;
  border: 1px solid #bbbbbb;
  border-radius: 5px;
  padding: 8px;
  margin-top: 8px;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.exist-text {
  width: 100%;
}

.exist-values {
  display: flex;
  justify-content: space-between;
  margin: 0 0.5rem 0.5rem 0;
}

.exist-values:last-child {
  margin-bottom: 0;
}

.values-label {
  width: 75%;
  text-align: justify;
}

.remove {
  text-align: center;
  background: #fff;
  border: 1px solid #000;
  border-radius: 20px;
  padding: 1px 5px 2px;
  margin: 3px 0 0 8px;
  cursor: pointer;
  font-weight: bolder;
}

.button {
  padding: 8px 16px;
  margin-top: 8px;
  margin-bottom: 8px;
}

.grid-col-1-2 {
  grid-column: 1 / 2;
}

.grid-col-1-3 {
  grid-column: 1 / 3;
}

.grid-col-2-3 {
  grid-column: 2 / 3;
}

.grid-row-1-2 {
  grid-row: 1 / 2;
}

.grid-row-2-3 {
  grid-row: 2 / 3;
}

.grid-row-3-4 {
  grid-row: 3 / 4;
}

.required {
  color: #f00;
}

.hint {
  color: #8a8a8a;
  margin-left: 5px;
  margin-top: 5px;
  font-size: 12px;
}

/* remove the arrow in datalist */
[list]::-webkit-calendar-picker-indicator {
  display: none !important;
}
</style>